import React from "react";
import { useState } from "react";
import { enviarContactoPublico } from "../../api/formulariosPublicos";
/* import './contacto.css' */

const CAMPOS_INICIALES = {
    name: "",
    surname: "",
    email: "",
    phone: "",
    city: "",
    message: "",
};

const ContactForm = () => {
    const [enviando, setEnviando] = useState(false);
    const [formValues, setFormValues] = useState(CAMPOS_INICIALES);
    const [estado, setEstado] = useState(null); // { tipo: 'exito' | 'error', mensaje: string }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (enviando) return; // anti doble-submit: evita mails repetidos

        setEnviando(true);
        setEstado(null);
        try {
            await enviarContactoPublico({
                nombre: formValues.name,
                apellido: formValues.surname,
                email: formValues.email,
                telefono: formValues.phone,
                localidad: formValues.city,
                mensaje: formValues.message,
            });
            setEstado({ tipo: "exito", mensaje: "Tu mensaje fue enviado. Gracias por contactarte." });
            setFormValues(CAMPOS_INICIALES);
        } catch (err) {
            console.error(err);
            setEstado({ tipo: "error", mensaje: err.message || "Error al enviar el mensaje. Intentá de nuevo." });
        } finally {
            setEnviando(false);
        }
    };

    return (
        <div className="contact">
        <div className="w-100">
            <center> <p className="contact-form__title display-5">CONTACTO</p></center>
        </div>

        <div className="contactgrid" style={{ gridAutoRows: 'auto' }}>
            <form className="contactform row g-3" onSubmit={handleSubmit}>
                <div className="col-md-6 m-0">
                    <label className="h5 form-label" htmlFor="name">Nombre:</label>
                    <input className="form-control border px-3 py-2 rounded placeholder-gray-500" type="text" id="name" name="name" value={formValues.name} onChange={handleChange} required />
                </div>
                <div className="col-md-6 m-0">
                    <label className="h5 form-label" htmlFor="surname">Apellido:</label>
                    <input className="form-control border px-3 py-2 rounded placeholder-gray-500" type="text" id="surname" name="surname" value={formValues.surname} onChange={handleChange} required />
                </div>

                <div className="col-md-6 m-0">
                    <label className="h5 form-label" htmlFor="email">Correo electrónico:</label>
                    <input className="form-control border px-3 py-2 rounded placeholder-gray-500" type="email" id="email" name="email" value={formValues.email} onChange={handleChange} required />
                </div>
                <div className="col-md-6 m-0">
                    <label className="h5 form-label" htmlFor="phone">Teléfono:</label>
                    <input className="form-control border px-3 py-2 rounded placeholder-gray-500" type="tel" id="phone" name="phone" value={formValues.phone} onChange={handleChange} required />
                </div>
                <div className="col-12 m-0">
                    <label className="h5 form-label" htmlFor="city">Localidad:</label>
                    <input className="form-control border px-3 py-2 rounded placeholder-gray-500" type="text" id="city" name="city" value={formValues.city} onChange={handleChange} required />
                </div>
                <div className="col-12 m-0">
                    <label className="h5 form-label" htmlFor="message">Mensaje:</label>
                    <textarea className="form-control border px-3 py-2 mb-1 rounded placeholder-gray-500" id="message" name="message" value={formValues.message} onChange={handleChange} required></textarea>
                </div>
                {estado && (
                    <div className="col-12 m-0" aria-live="polite">
                        <div className={estado.tipo === "exito" ? "alert alert-success" : "alert alert-danger"} role={estado.tipo === "error" ? "alert" : "status"}>
                            {estado.mensaje}
                        </div>
                    </div>
                )}
                <div className="col-12 m-0">
                    <div className="position-relative">
                        <button className="btn btn-outline-danger bg-white px-5 py-2" type="submit" disabled={enviando}><h3>{enviando ? 'Enviando...' : 'Enviar'}</h3></button>
                    </div>
                </div>
            </form>

            <div className="contactmap">
                <iframe className="iframemap"
                    src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d722.1840882791661!2d-65.29321710850304!3d-24.186469156274907!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1ses!2sar!4v1684930746863!5m2!1ses!2sar"
                    /* width="50%"
                    height="250" */  // Altura reducida
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    title="Google Maps"
                ></iframe>
            </div>
        </div>
    </div>


    );
};

export default ContactForm;
